module["exports"] = ["Leil. ###", "Oppgang A", "Oppgang B"];